import { Helmet } from "react-helmet-async"
import { ForbidUnlessAuthorized, PERMISSIONS } from "../../../../Auth"
import { HotelCalendar, type IHotel } from "../../../../Hotels"
import { useOutletContext } from "../../../../router-utils"

export default function HotelCalendarPage() {
	const { hotel } = useOutletContext<{ hotel: IHotel }>()
	return (
		<>
			<Helmet>
				<title>Calendar | Hotel</title>
			</Helmet>
			<ForbidUnlessAuthorized anyPermissions={[PERMISSIONS.MANAGE_USERS]}>
				<HotelCalendar hotel={hotel} />
			</ForbidUnlessAuthorized>
		</>
	)
}
